import React from 'react';
import MobileLayout from "../../../../components/Page/components/MobileLayout";
import Header from "../../../../components/common/Header/Header";
import { Mobile, useTranslation } from '@edreamsodigeo/frontend-core';
import { Box, Heading } from '@edreamsodigeo/prisma-design-system';
import FlightSelectorLCSection from "./FlightSelectorLCSection";
const FlightSelectorLCMobilePage = ({
  bookingId,
  isPrime,
  legs,
  onClickBack,
  onClickLink,
  modifiable
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Mobile, null, /*#__PURE__*/React.createElement(Header, {
    bookingId: bookingId,
    isPrime: isPrime,
    title: t('managebooking.change.lc.info.title'),
    onClickBack: onClickBack,
    onClickLink: onClickLink,
    isLCFlow: true
  })), /*#__PURE__*/React.createElement(MobileLayout, null, /*#__PURE__*/React.createElement(Box, {
    pb: ['base', 'big']
  }, /*#__PURE__*/React.createElement(Heading, {
    type: [2, 3],
    color: "neutral.100"
  }, t('managebooking.modifytrip.changes.flightselector.heading.title'))), /*#__PURE__*/React.createElement(FlightSelectorLCSection, {
    legs: legs,
    modifiable: modifiable
  })));
};
export default FlightSelectorLCMobilePage;